const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.RUNNING = 1;
GameStatus.TIMEOUT = 2;

export default GameStatus;